import { Avatar, makeStyles, Typography, useTheme } from "@material-ui/core";

import type { CoretexTheme } from "../../theme";

interface DefaultAvatarProps {
  initials: string;
  backgroundColour?: string;
  textColour?: string;
}

const useStyles = makeStyles((theme: CoretexTheme) => ({
  root: {
    width: 32,
    height: 32,
  },
  text: {
    fontWeight: theme.typography.fontWeightBold as number,
    fontSize: theme.typography.subtitle2.fontSize,
    textTransform: "uppercase",
  },
}));

const DefaultAvatar = ({ initials, backgroundColour, textColour }: DefaultAvatarProps): JSX.Element => {
  const classes = useStyles();
  const sanitisedInitials = initials.substr(0, 2);
  const theme = useTheme<CoretexTheme>();

  return (
    <Avatar style={{ backgroundColor: backgroundColour || theme.palette.secondary.dark }} className={classes.root}>
      <Typography style={{ color: textColour || theme.palette.mono.white }} className={classes.text}>
        {sanitisedInitials}
      </Typography>
    </Avatar>
  );
};

export default DefaultAvatar;
